import React from "react";
import CountriesPageGen from "./generated/CountriesPageGen";
import countriesService from "../../../services/legacy/countriesService";

const SHOW_IN_GRID = new Set(["countryid", "name", "isocode", "type"]);
const SHOW_IN_FILTER = new Set(["countryid", "name", "isocode", "type"]);

const transformColumns = (baseColumns) => {
  return baseColumns.map((column) => ({
    ...column,
    showInGrid: SHOW_IN_GRID.has(column.key),
    showInFilter: SHOW_IN_FILTER.has(column.key),
  }));
};

const CountriesPage = () => {
  const service = countriesService;
  return <CountriesPageGen service={service} transformColumns={transformColumns} />;
};

export default CountriesPage;